import { render, staticRenderFns } from "./user-examine.vue?vue&type=template&id=5c9caff2&scoped=true&"
import script from "./user-examine.vue?vue&type=script&lang=js&"
export * from "./user-examine.vue?vue&type=script&lang=js&"
import style0 from "./user-examine.vue?vue&type=style&index=0&id=5c9caff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9caff2",
  null
  
)

export default component.exports